<template>
    <div>
        <div class="registration-section__submit-errors">
            <div
                v-if="!_isEmpty(errors)"
                class="message message--error-big"
            >
                {{ $t('you have fields errors, please check the form') | capitalize }}.
            </div>
        </div>
        <div class="registration-section__submit">
            <CustomButton
                type="submit"
                :isLoading="isLoading"
                class="btn btn__primary mt-2 mb-4 btn--w-144"
            >
                {{ $t('register') | capitalize }}
            </CustomButton>
        </div>
    </div>
</template>

<script>
    import {
        isEmpty as _isEmpty,
    } from '@lodash';

    export default {
        props: {
            isLoading: {
                type: Boolean,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
        },
        created() {
            // eslint-disable-next-line no-underscore-dangle
            this._isEmpty = _isEmpty;
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/components/register/Submit.vue